import tileReggioEmilia01 from "assets/hard/AV-REGGIO-EMILIA/01.jpg";
import tileReggioEmilia02 from "assets/hard/AV-REGGIO-EMILIA/02.jpg";
import tileReggioEmilia03 from "assets/hard/AV-REGGIO-EMILIA/03.jpg";
import tileReggioEmilia04 from "assets/hard/AV-REGGIO-EMILIA/04.jpg";
import tileReggioEmilia05 from "assets/hard/AV-REGGIO-EMILIA/05.jpg";
import tileReggioEmilia06 from "assets/hard/AV-REGGIO-EMILIA/06.jpg";
import tileReggioEmilia07 from "assets/hard/AV-REGGIO-EMILIA/07.jpg";
import tileReggioEmilia08 from "assets/hard/AV-REGGIO-EMILIA/08.jpg";
import tileReggioEmilia09 from "assets/hard/AV-REGGIO-EMILIA/09.jpg";
import tileReggioEmilia10 from "assets/hard/AV-REGGIO-EMILIA/10.jpg";
import tileReggioEmilia11 from "assets/hard/AV-REGGIO-EMILIA/11.jpg";
import tileReggioEmilia12 from "assets/hard/AV-REGGIO-EMILIA/12.jpg";
import tileReggioEmilia13 from "assets/hard/AV-REGGIO-EMILIA/13.jpg";
import tileReggioEmilia14 from "assets/hard/AV-REGGIO-EMILIA/14.jpg";
import tileReggioEmilia15 from "assets/hard/AV-REGGIO-EMILIA/15.jpg";
import tileReggioEmilia16 from "assets/hard/AV-REGGIO-EMILIA/16.jpg";
import tileReggioEmilia17 from "assets/hard/AV-REGGIO-EMILIA/17.jpg";
import tileReggioEmilia18 from "assets/hard/AV-REGGIO-EMILIA/18.jpg";
import tileReggioEmilia19 from "assets/hard/AV-REGGIO-EMILIA/19.jpg";
import tileReggioEmilia20 from "assets/hard/AV-REGGIO-EMILIA/20.jpg";
import tileReggioEmilia21 from "assets/hard/AV-REGGIO-EMILIA/21.jpg";
import tileReggioEmilia22 from "assets/hard/AV-REGGIO-EMILIA/22.jpg";
import tileReggioEmilia23 from "assets/hard/AV-REGGIO-EMILIA/23.jpg";
import tileReggioEmilia24 from "assets/hard/AV-REGGIO-EMILIA/24.jpg";
import tileReggioEmilia25 from "assets/hard/AV-REGGIO-EMILIA/25.jpg";
import tileReggioEmilia26 from "assets/hard/AV-REGGIO-EMILIA/26.jpg";
import tileReggioEmilia27 from "assets/hard/AV-REGGIO-EMILIA/27.jpg";
import tileReggioEmilia28 from "assets/hard/AV-REGGIO-EMILIA/28.jpg";
import tileReggioEmilia29 from "assets/hard/AV-REGGIO-EMILIA/29.jpg";
import tileReggioEmilia30 from "assets/hard/AV-REGGIO-EMILIA/30.jpg";
import tileReggioEmilia31 from "assets/hard/AV-REGGIO-EMILIA/31.jpg";
import tileReggioEmilia32 from "assets/hard/AV-REGGIO-EMILIA/32.jpg";
import tileReggioEmilia33 from "assets/hard/AV-REGGIO-EMILIA/33.jpg";
import tileReggioEmilia34 from "assets/hard/AV-REGGIO-EMILIA/34.jpg";
import tileReggioEmilia35 from "assets/hard/AV-REGGIO-EMILIA/35.jpg";
import tileReggioEmilia36 from "assets/hard/AV-REGGIO-EMILIA/36.jpg";
import fullImage from "assets/hard/AV-REGGIO-EMILIA/complete.jpg";

import { ILevel, LevelDifficulties, LevelTypes } from "models";

export const reggioEmilia: ILevel = {
  difficulty: LevelDifficulties.hard,
  type: LevelTypes.station,
  name: "Reggio Emilia AV Mediopadana",
  fullImage,
  successDialogContent: {
    subtitle: "Hai (ri)costruito la stazione REGGIO EMILIA AV MEDIOPADANA",
    link: `https://www.fsitaliane.it/content/fsitaliane/it/innovazione/tecnologie-per-i-trasporti/le-principali-stazioni-av/reggio-emilia-av-mediopadana.html`,
    contents: [
      {
        text: "Questa stazione corre ",
        isBold: false,
      },
      {
        text: "verso il futuro",
        isBold: true,
      },
      {
        text:
          " seguendo due binari complementari. Da una parte, contribuisce allo sviluppo del ",
        isBold: false,
      },
      {
        text: "patrimonio culturale italiano",
        isBold: true,
      },
      {
        text:
          ", grazie alla sua estetica avveniristica progettata dal grande architetto spagnolo ",
        isBold: false,
      },
      {
        text: "Santiago Calatrava",
        isBold: true,
      },
      {
        text: ". Dall’altra, realizza un modello innovativo di ",
        isBold: false,
      },
      {
        text: "mobilità integrata e sostenibile",
        isBold: true,
      },
      {
        text: ", dando vita a un importante nodo di ",
        isBold: false,
      },
      {
        text: "scambio intermodale",
        isBold: true,
      },
      {
        text:
          " che sfrutta l’interconnessione con le linee ferroviarie locali e regionali.",
        isBold: false,
      },
    ],
  },
  tiles: [
    tileReggioEmilia01,
    tileReggioEmilia02,
    tileReggioEmilia03,
    tileReggioEmilia04,
    tileReggioEmilia05,
    tileReggioEmilia06,
    tileReggioEmilia07,
    tileReggioEmilia08,
    tileReggioEmilia09,
    tileReggioEmilia10,
    tileReggioEmilia11,
    tileReggioEmilia12,
    tileReggioEmilia13,
    tileReggioEmilia14,
    tileReggioEmilia15,
    tileReggioEmilia16,
    tileReggioEmilia17,
    tileReggioEmilia18,
    tileReggioEmilia19,
    tileReggioEmilia20,
    tileReggioEmilia21,
    tileReggioEmilia22,
    tileReggioEmilia23,
    tileReggioEmilia24,
    tileReggioEmilia25,
    tileReggioEmilia26,
    tileReggioEmilia27,
    tileReggioEmilia28,
    tileReggioEmilia29,
    tileReggioEmilia30,
    tileReggioEmilia31,
    tileReggioEmilia32,
    tileReggioEmilia33,
    tileReggioEmilia34,
    tileReggioEmilia35,
    tileReggioEmilia36,
  ],
};
